import React from "react";
import helpVector from "./HelpVector.png";

export const HelpIcon = () => (
  <img
    src={helpVector}
    alt=""
    aria-hidden
    width={24}
    height={24}
    style={{ display: "block" }}
  />
);
